export default {
  errors: {
    bday: {
      invalid_date: 'Invalid birthday date',
      max_date_limit: 'Invalid birthday date'
    }, 
    password: {
      wrong_confirmed_password: 'Passwords do not match',
      max_limit: 'Password max character limit reached'
    },
    email: {
      not_available: 'Email not available',
      not_valid: 'Email not valid'
    },
    too_many_request: 'Too many request, please wait'
  },
  home: {
    title: 'Home',
    new_users: 'New Users',
    total_clicks: 'Total Clicks',
    total_QnA: 'Total Q&A',
    total_share: 'Total Share',
    total_chat: 'Total Chat',
    total_pages: 'Total Pages',
    total_interview: 'Total Interviews',
    email_marketing: 'Email Marketing',
    affiliate_advertising: 'Affiliate Advertising',
    video_advertising: 'Video Advertising',
    search_engine: 'Search Engine',
    users_access: 'Users Access',
    users_activity: 'Users Activity'
  },
  example: {
    total: 'Total',
    carrier_network: 'Carrier/Network Services',
    bank_securities: 'Bank/Securities',
    gaming_video: 'Gaming/Video',
    catering_takeaway: 'Catering/Takeaway',
    courier_ecommerce: 'Courier/e-commerce'
  },
  login: {
    title: 'Login',
    form: {
      title: 'Please login to My Doctor!',
      username: 'Your email address',
      password: 'Your password',
      forgot_question: 'Forgot password?',
      login: 'Login',
      logout: 'Logout',
      login_form: 'Back',
      recover: 'Recover',
      or: 'Or'
    },
    register: {
      invitation: 'Do not have an account yet?',
      now: 'Register now!'
    },
    social: {
      facebook: 'Login with Facebook',
      google: 'Login with Google',
      linkedin: 'Login with Linkedin'
    },
    messages: {
      error: {
        username: 'Username cannot be empty',
        password: 'Password cannot be empty',
        email: 'Invalid email format',
        missing_info: 'Missing Information'
      },
      success: {
        welcome: 'Welcome user: {username}',
        recover_send: 'New Password sended to {username}'
      }
    },
    tips: {
      bottom: 'Enter any username and password'
    }
  },
  register: {
    title: 'Register',
    form: {
      title: 'Please register to My Doctor!',
      name: { 
        label: 'Name',
        placeholder: 'Your name'
      },
      last_name: {
        label: 'Last name',
        placeholder: 'Your last name'
      },
      email: {
        label: 'Email',
        placeholder: 'Your email address'
      },
      password: {
        label: 'Password',
        placeholder: 'Your password'
      },
      confirm_password: {
        label: 'Confirm password',
        placeholder: 'Confirm password'
      },
      agree_terms: 'I Agree to the <strong>Terms &amp; Conditions</strong>',
      send: 'Submit',
      footer_tip: 'Has voluptua vivendum accusamus cu. Ut per assueverit temporibus dissentiet. Eum no atqui putant democritum, velit nusquam sententiae vis no.'
    },
    messages: {
      error: {
        missing_info: 'Missing Information',
        empty_name: 'Please fill this field',
        empty_email: 'Please fill this field',
        invalid_email: 'Invalid email format',
        empty_password: 'Please fill this field',
        incorrect_password: 'Passwords do not match',
        please_accept_terms: 'Please accept terms and conditions',
        'Network Error': 'Unable to connect to web server'
      },
      success: {
        registered: 'successfully user registered'
      }
    }
  },
  register_doctor: {
    title: 'Register doctor',
    form: {
      title: 'It\'s time to find you!',
      content: {
        lead: 'Te pri adhuc simul. No eros errem mea. Diam mandamus has ad. Invenire senserit ad has, has ei quis iudico, ad mei nonumes periculis.',
        box_1: {
          title: 'Let patients to Find you!',
          content: 'Ut nam graece accumsan cotidieque. Has voluptua vivendum accusamus cu. Ut per assueverit temporibus dissentiet.',
        },
        box_2: {
          title: 'Easly manage Bookings',
          content: 'Has voluptua vivendum accusamus cu. Ut per assueverit temporibus dissentiet. Eum no atqui putant democritum, velit nusquam sententiae vis no.'
        },
        box_3: {
          title: 'Instantly via Mobile',
          content: 'Eos eu epicuri eleifend suavitate, te primis placerat suavitate his. Nam ut dico intellegat reprehendunt, everti audiam diceret in pri, id has clita consequat suscipiantur.'
        }
      },
      name: 'Name',
      last_name: 'Last Name',
      specialization: 'Specialization',
      city: 'City',
      country: 'Country',
      address: 'Address',
      mobile_phone: 'Mobile Phone',
      office_phone: 'Office Phone',
      email_address: 'Email Address',
      submit: 'Submit',
      footer_tip: 'Ut nam graece accumsan cotidieque. Has voluptua vivendum accusamus cu. Ut per assueverit temporibus dissentiet.'
    },
    messages: {
      error: {
        missing_info: 'Missing Information'
      },
      success: {
        sended: 'successfully Doctor registered'
      }
    }
  },
  list_page: {
    title: 'List Page'
  },
  contacts: {
    title: 'Contact us',
    header: {
      title: 'Contacts Info',
      administration: 'Administration',
      questions: 'General questions',
      directions: {
        title: 'Get directions',
        enter_location: 'Enter your location',
        send: 'Get directions'
      }
    },
    form: {
      title: 'Contact us',
      legend: 'Mussum ipsum cacilds, vidis litro abertis.',
      name: 'Name',
      last_name: 'Last name',
      email: 'Email',
      phone: 'Phone number',
      message: 'Hello doctor',
      submit: 'Submit'
    },
    messages: {
      error: {
        missing_info: 'Missing information'
      },
      success: {
        sended: 'successfully Info sended'
      }
    }
  },
  i18n: {
    title: 'Internationalization',
    modalTitle: 'Modal Title',
    content: 'This is the modal box content.',
    buttonText: 'Show Modal',
    tip: 'Note: Only this page is multi-language, other pages do not add language content to the multi-language package.',
    select_date: 'Select date',
    select_time: 'Select time'
  },
  join: {
    title: 'Community',
    qq_number: 'QQ Group number: {number}',
    zhihu_column: 'iView meet the column',
    juejin: 'Juejin',
    bilibili: 'Event Live Room',
    twitter: 'Twitter'
  },
  treeSelect: {
    update_selected_data: 'Update selected data',
    update_tree_data: 'Update tree data'
  },
  countTo: {
    title: 'Count-to component basic usage',
    total: 'Total',
    times: 'times',
    left_right: 'Add left and right text',
    custom_style: 'Custom style',
    format_data: 'Format he data',
    convert_data: 'Convert units to simplify data',
    custom_units: {
      title: 'Custom units',
      raw: 'Raw data：{number} => '
    },
    async_data: 'Data can be updated asynchronously',
    example: 'Comprehensive example',
    qty: {
      thousand: 'Thousand',
      tenthousand: 'Ten thousand',
      over_hundred_thousand: 'Over 100,000',
      over_million: 'Over a million',
      over_ten_million: 'Over ten million',
      billion: 'Billion',
      dozen: 'Dozen',
      hundred: 'Hundred'
    }
  },
  dragList: {
    toDo: 'To-Do',
    completion: 'Completion',
    operation_record: 'Operation record'
  },
  dragDrawer: {
    content: 'drawer component is an encapsulation of the iview\'s drawer component. It supports draggable and footer bottom slots on the basis of supporting all apis of the drawer',
    direction: 'Direction',
    left: 'left',
    right: 'Right',
    whether_draggable: 'Whether draggable',
    close: 'Shutdown',
    open: 'Turn On',
    container_drawer: 'Container Drawer',
    open_fullscreen: 'Open fullscreen',
    example: {
      title: 'This is the title'
    },
    show_miltilayer: 'Show multiple layers'
  },
  orgTree: {
    documentation: 'Documentation',
    menu: {
      editorial_department: 'Editorial Department',
      view_department: 'View Department',
      new_sector: 'New sub-sector',
      delete_department: 'Delete department',
      click: 'Clicked on the \'{key}\' menu of the "{label}" node'
    }
  },
  treeTable: {
    name: 'Tree table component',
    based_on: 'based on',
    develop: 'develop',
    fixed_some: 'Fixed some bugs',
    add_features: 'Added some new attributes',
    supported_slot: 'Supported use',
    perfom_custom_column: 'Perform custom column rendering',
    see_documentation: 'See the documentation',
    columns: {
      name: 'Name',
      gender: 'Gender',
      score: 'Score',
      likes: 'Likes'
    }
  },
  cropper: {
    button: 'Confirm Submit',
    button_crop: 'Crop',
    upload_image: 'Upload Image',
    messages: {
      success: {
        upload: 'Upload success~'
      }
    }
  },
  table: {
    export_csv: 'Export as Csv file',
    columns: {
      name: 'Name',
      email: 'Email',
      create_time: 'Create-Time',
      handle: 'Handle',
      delete_message: 'Are you sure you want to delete?',
      delete_button: 'Custom delete'
    },
    search_placeholder: 'Enter keyword search',
    search_button: 'Search For'
  },
  richEditor: {
    button: 'Modify editor content'
  },
  icons: {
    builtin_icon: 'iView built-in icon',
    feature: 'The Icons component supports the display of custom icons. For the creation of custom icon font files, please refer to the document.',
    feature2: 'CommonIcon component supports both iView built-in icon type and custom icon type. In order to distinguish these two types, you need to underline the custom icon name"_"'
  },
  uploadTable: {
    upload_csv: 'Upload Csv file',
    tip_upload: 'Click to upload Csv file',
    utilsjs: {
      tip: 'util.js provides two methods to achieve this function',
      get_array: 'Parsing a Csv file into a two-dimensional array',
      get_table: 'Convert two-dimensional arrays into tabular data, see the documentation for details'
    },
    csv_first_row: 'First row is header',
    only_csv_files: 'Can only upload Csv files',
    only_csv_files_again: 'Only Csv files can be uploaded, please upload again'
  },
  pasteTable: {
    paste_tip: 'Use the Tab key to change columns, use the Enter key to wrap',
    show_data: 'Show tabular data',
    messages: {
      error: {
        irregular: 'Your content is irregular',
        row_irregular: 'Your {errorIndex} row data is irregular, please modify'
      }
    }
  },
  uploadExcel: {
    title: 'Import Excel',
    upload_file: 'Upload files',
    success: 'Success',
    messages: {
      info: {
        file_deleted: 'The uploaded file has been deleted！'
      },
      error: {
        file_type: 'File type error',
        no_excel: 'File：{name} not an excel file，please select an excel file with a .xlsx or .xls extension。',
        reading: 'File reading error'
      },
      success: {
        read: 'File read successfully'
      }
    }
  },
  exportExcel: {
    title: 'Export Excel',
    export_file: 'Export File',
    example: {
      columns: {
        primary: 'Primary classification',
        secondary: 'Secondary classification',
        tertiary: 'Tertiary classification'
      },
      result: 'Category List'
    },
    messages: {
      error: {
        empty: 'Form data cannot be empty！'
      }
    }
  },
  toolsMethods: {
    add_label: 'Add Label',
    dynamic_routing: 'Dynamic routing',
    add: 'Add ',
    parameter: 'parameter',
    close_this: 'Close the tool method page',
    close_manually: 'Close the page manually'
  },
  arguPage: {
    params: {
      close_button: 'Call closeTag method to close this page'
    },
    query: {
      close_button: 'Call closeTag method to close this page'
    }
  },
  errorStore: {
    content1: 'iview-admin will automatically collect errors in your program, you can send the error log to the backend to save it. If you do not need this feature, delete the \'error-store\' attribute of the plugin in \'./src/config/index.js\'.',
    content2: 'In addition, in the development environment, errors in your program will be collected. This may not help you troubleshoot errors. You can change \'./src/config/index.js\'\'error-store\'\'developmentOff\' is set to true.',
    content3: 'If you just want to collect error logs and don\'t want logged in users to see the error logs, you can not provide an entry to view the logs, just add \'./src/config/index.js\' \'error-store\' \'ShowInHeader\' is set to false.',
    click_test_error: 'Click test trigger error',
    click_test_ajax_error: 'Click test triggers ajax interface request error',
    ajax_error_404: 'The ajax interface request is a non-existing interface for the easy-mock request, so the server will report a 404 error, and the error collection mechanism will collect this error. There is a certain network delay during the test, so it will be collected after you click the button. error.'
  },
  errorLogger: {
    button_export: 'Export logging',
    logger_note: 'Note: Only the error log saved to the server will be displayed here, and the page error log will not be stored persistently in the browser, and the page will be lost when refresh',
    columns: {
      serial_number: 'Serial Number',
      type: 'Type',
      code: 'Code',
      information: 'Information',
      url: 'URL',
      time: 'Time'
    },
    file_name: 'Error log'
  },
  directives: {
    show_modal: 'Show draggable popup',
    this_button_draggable: 'This button is also draggable',
    modal_title: 'Title',
    drag_here: 'Drag here to drag the entire popup',
    copy_button: 'Copy',
    copy_succed: 'Copy succeeded',
    copy_failedd: 'Copy failed',
    entered_input: 'This is what is entered'
  },
  multilevel: {
    level: {
      menu: 'Multi-level menu',
      second: 'Level-{second}',
      third: 'Level {third}-{forth}'
    }
  },
  messageCenter: {
    unread_message: 'Unread messages',
    read_message: 'Read messages',
    recycle_bin: 'Recycle Bin',
    title_delete: 'Delete',
    title_restore: 'Restore'
  },
  menu: {
    components: {
      title: 'Components',
      submenu: {
        tree_select_page: {
          title: 'Tree Selector'
        },
        count_to_page: {
          title: 'Count-to'
        },
        drag_list_page: {
          title: 'Drag-list'
        },
        drag_drawer_page: {
          title: 'Draggable Drawer'
        },
        org_tree_page: {
          title: 'Org Tree'
        },
        tree_table_page: {
          title: 'Tree Table'
        },
        cropper_page: {
          title: 'Cropper'
        },
        tables_page: {
          title: 'Table'
        },
        split_pane_page: {
          title: 'Split-pane'
        },
        markdown_page: {
          title: 'Markdown-editor'
        },
        editor_page: {
          title: 'Rich-Text-Editor'
        },
        icons_page: {
          title: 'Custom-icon'
        }
      }
    },
    img_cropper_page: 'Image-editor',
    update: {
      title: 'Update',
      submenu: {
        update_table_page: {
          title: 'Update .CSV'
        },
        update_paste_page: {
          title: 'Paste Table Data'
        }
      }
    },
    join_page: {
      title: 'QQ Group'
    },
    doc: {
      title: 'Document'
    },
    multilevel: {
      title: 'Multilevel',
      submenu: {
        level_1: {
          title: 'Level-1'
        },
        level_2: {
          title: 'Level-2'
        },
        level_2_1: {
          title: 'Level-2-1'
        },
        level_2_3: {
          title: 'Level-2-3'
        },
        level_2_2: {
          title: 'Level-2-2',
          submenu: {
            level_2_2_1: {
              title: 'Level-2-2-1'
            },
            level_2_2_2: {
              title: 'Level-2-2-2'
            }
          }
        }
      }
    },
    directive_page: {
      title: 'Directive'
    },
    excel: {
      title: 'Excel',
      submenu: {
        'upload-excel': {
          title: 'Upload Excel'
        },
        'export-excel': {
          title: 'Export Excel'
        }
      }
    },
    tools_methods_page: {
      title: 'Tools Methods'
    },
    error_store_page: {
      title: 'Error Collection'
    },
    error_logger_page: {
      title: 'Error Logger'
    },
    query: 'Query',
    params: 'Params'
  },
  top: {
    message_page: {
      title: 'Message Center'
    },
    fullscreen: {
      open: 'Fullscreen',
      exit: 'Exit fullscreen'
    },
    tags: {
      close_all: 'Close All',
      close_other: 'Close Others'
    }
  },
  date: {
    week: {
      Mon: 'Mon',
      Tue: 'Tue',
      Wed: 'Wed',
      Thu: 'Thu',
      Fri: 'Fri',
      Sat: 'Sat',
      Sun: 'Sun'
    }
  },
  modal: {
    close: {
      title: 'Are you sure you want to close this page?'
    }
  },
  footer: {
    about: 'About',
    about_us: 'About Us',
    blog: 'Blog',
    faq: 'FAQ',
    login: 'Login',
    register: 'Register',
    useful_links: 'Useful Links',
    doctors: 'Doctors',
    clinic: 'Clinics',
    specialization: 'Specialization',
    join_doctor: 'Join as a Doctor',
    download_app: 'Download App',
    contact_us: 'Contact with Us',
    follow_us: 'Follow Us',
    terms_conditions: 'Terms and conditions',
    privacy: 'Privacy'
  },
  header: {
    menu: {
      home: 'Home',
      home_default: 'Home Default',
      home_2: 'Home Default 2',
      home_3: 'Home Default 3',
      home_4: 'Home Default 4',
      revolution_slider: 'Revolution Slider',
      home_cookie: 'With Cookie bar (EU law)',
      pages: 'Pages',
      list_page: 'List Page',
      list_grid: 'List Grid Page',
      list_map: 'List Map Page',
      detail_page: 'Detail Page',
      detail_page_2: 'Detail Page 2',
      detail_page_3: 'Detail Page 3',
      blog: 'Blog',
      badges: 'Badges',
      login: 'Login',
      login_2: 'Login 2',
      register_doctor: 'Register Doctor',
      register: 'Register',
      contacts: 'Contacts',
      extra_elements: 'Extra Elements',
      detail_working_booking: 'Detail Working Booking',
      booking_page: 'Booking Page',
      confirm_page: 'Confirm Page',
      faq_page: 'FAQ Page',
      comming_soon: 'Comming Soon',
      responsive_pricing_table: 'Responisve Pricing Table',
      responsive_pricing_table_2: 'Responsive Pricing Table 2',
      working_doctor_register: 'Working doctor register',
      icon_pack_1: 'Icon Pack 1',
      icon_pack_2: 'Icon Pack 2',
      icon_pack_3: 'Icon Pack 3',
      no_found_page: '404 Page',
      menu_v2: 'Menu V2',
      admin: 'Admin',
      buy_template: 'Buy this template'
    }
  },
  home_page: {
    app_section: {
      application: 'Application',
      download_app: 'Download',
      app_name: '{name} App',
      download_now: 'Now!',
      app_description: 'I\'ve created a simple app where you can search for head lice and track your progress and see if you are out of lice yet. Check it out at https://mydoctorapp.com Check out my projects on GitHub Mydoctor App & my project http://getchik.me - A mobile app for tracking kids with cancer'
    }
  },
  types: {
    all: 'All',
    pacient: 'Pacients',
    doctor: 'Doctors',
    nurse: 'Nurses',
    clinic: 'Clinics',
    client: 'Clients',
    customer: 'Customers',
    provider: 'Providers',
    enfermero_a: 'Nurses',
    sucursal: 'Offices',
    clinicas: 'Clinics'
  },
  sorts: {
    closest: 'Closest', 
    best_rated: 'Best rated', 
    oldest: 'Oldest', 
    youngest: 'Youngest',
    most_viewed: 'Most Viewed'
  },
  details_page: {
    title: 'Medical Information'
  },
  booking_page: {
    title: 'Schedule appontment & payment'
  },
  profile: {
    title: 'Profile',
    clients: {
      genere: {
        male: 'Male',
        female: 'Female',
        other: 'Other',
        'not sure': 'Not sure',
        'rather not say': 'Rather not say'
      }
    }
  },
  payment_status : {
    CANCELED: 'Cancelled',
    PAID: 'Paid',
    PENDING: 'Pending',
    AWAITING: 'Awaiting payment',
    COMPLETED: 'Completed',
    DECLINED: 'Declined',
    REFUNDED: 'Refunded',
    DISPUTED: 'Disputed',
  }, 
  appointment_status: {
    SCHEDULED: 'Scheduled',
    NO_SHOW: 'No show',
    PENDING_APPROVAL: 'pending approval',
    REQUEST_EXPIRED: 'request expired',
    NEW_TIME_PROPOSED: 'New time proposed',
    PENDING_RESCHEDULE: 'Pending reschedule',
  },
  invoice_page: {
    title: 'Order details'
  },
  products: {
    title: 'Product'
  },
  services: {
    title: 'Service'
  }
}
